
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  head() {
    return {
      title: "Comment améliorer les Core Web Vitals d'un site pour le SEO",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "Les Core Web Vitals influencent le classement Google. Découvrez comment optimiser la vitesse, l’interactivité et la stabilité de votre site avec ALEO pour booster votre SEO.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content:
            "Comment améliorer les Core Web Vitals d'un site pour le SEO",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "Les Core Web Vitals influencent le classement Google. Découvrez comment optimiser la vitesse, l’interactivité et la stabilité de votre site avec ALEO pour booster votre SEO.",
        },
      ],
    };
  },
};
